const Loading = ({ text = 'loading...' }) => {
    return (
        <div className="loading-mask">
            <span>{text} <i className="fa fa-spinner fa-spin fa-fw load_spiner" /></span>
        </div>
    );
};

export default Loading;
